const state = {
    type: null,
    visible: false,
    message: null,
};

const actions = {
    handleError: ({commit}, message) => {
        commit("displaySnackbar", {
            type: "error",
            message: message,
        });
    },

    handleSuccess: ({commit}, message) => {
        commit("displaySnackbar", {
            type: "success",
            message: message,
        });
    },
};

const mutations = {
    displaySnackbar: (state, payload) => {
        state.type = payload.type;
        state.message = payload.message;
        state.visible = true;
    },

    hideSnackbar: (state, newValue) => {
        state.visible = newValue;
    },
};

export default {
    state,
    actions,
    mutations,
};